
import React, {Component} from 'react';
import {Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import SWTCarEditModal from './SWTCarEditModal'


class SWTNewCarButton extends Component {

  constructor(...args){
    super(...args)
    this.state = {show:false}
  }

  onClick(){
    let catId = 0
    //this.refs.swtCustPage.loadPage()
    this.setState({show:true})
    if(this.props.onClick!==undefined){
      catId = this.props.onClick()
    }
    this.refs.newCustomerPop.openPopup(catId)    
  }

  render(){
    let {show} = this.state
    return (
      <div>        
        <Button  onClick={this.onClick.bind(this)}><FontAwesome name='plus'/></Button>        
        <SWTCarEditModal ref={'newCustomerPop'} show={show} 
        onChange={this.props.onChange} 
        onClick={this.props.onClick}
        onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}


export default SWTNewCarButton;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewCarButton.js